import * as React from 'react'
import * as DialogPrimitive from '@radix-ui/react-dialog'

import { cn, createComponent } from '@lair-finance/util'
import { AssetIcon } from '@/shared/ui/Asset'
import { TouchableButton } from '@/shared/ui/TouchableButton'

export const Dialog = DialogPrimitive.Root

export const DialogTitle = DialogPrimitive.Title

export const DialogTrigger = DialogPrimitive.Trigger

export const DialogPortal = DialogPrimitive.Portal

export const DialogClose = DialogPrimitive.Close

export const DialogOverlay = createComponent<
  React.ElementRef<typeof DialogPrimitive.Overlay>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Overlay>
>(
  ({ className, ...props }, ref) => (
    <DialogPrimitive.Overlay
      ref={ref}
      className={cn(
        'fixed inset-0 z-50 bg-[rgba(76,80,98,.50)] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
        className,
      )}
      {...props}
    />
  ),
  'DialogOverlay',
)

export const DialogContent = createComponent<
  React.ElementRef<typeof DialogPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content> & {
    noStyle?: boolean
    title?: string
    showClose?: boolean
  }
>(
  ({ noStyle, title, showClose, className, children, ...props }, ref) => (
    <DialogPrimitive.Content
      ref={ref}
      className={cn(
        'z-50 flex flex-col duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] outline-0',
        {
          'fixed left-[50%] top-[50%] w-[calc(100%-40px)] max-w-[335px] sm:max-w-[426px] translate-x-[-50%] translate-y-[-50%] border border-greyscale-500 rounded-[16px] bg-greyscale-600 p-[19px] sm:p-[23px] shadow-[0_0_8px_0_#30354A]':
            !noStyle,
        },
        className,
      )}
      {...props}
    >
      {title && (
        <DialogTitle className={'mb-4 sm:mb-6 flex items-center'}>
          <p className={'typo-heading-2 sm:typo-heading-1 text-greyscale-100'}>{title}</p>
        </DialogTitle>
      )}
      {showClose && (
        <DialogPrimitive.Close className={'absolute top-[15px] sm:top-5 right-3 sm:right-4 disabled:pointer-events-none'}>
          <TouchableButton size={40} as={'div'}>
            <AssetIcon filename={'close.png'} size={24} />
          </TouchableButton>
          <span className="sr-only">Close</span>
        </DialogPrimitive.Close>
      )}
      {children}
    </DialogPrimitive.Content>
  ),
  'DialogOverlay',
)
